import React from 'react';
import { connect } from 'react-redux';

import Button from '@components/button/Button.tsx';
import Icon from '@components/icon/Icon.tsx';
import { StoreT } from '@global/types.ts';

import ExecutorsAboutI from './types.ts';

import renderCards from './renders/renderCards.tsx';
import cards from './static/cards.ts';

class ExecutorsAbout
    extends React.Component<ExecutorsAboutI['props'], ExecutorsAboutI['state']>
    implements ExecutorsAboutI
{
    parent: ExecutorsAboutI['parent'];

    constructor(props: ExecutorsAboutI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    cards = cards;

    renderCards = renderCards;

    render() {
        const { device } = this.props;

        return (
            <section className="publicExecutorsAbout">
                <div className="publicExecutorsAbout__inner">
                    <div className="publicExecutorsAbout__content _col">
                        <div className="publicExecutorsAbout__contentBack" />
                        <div className="publicExecutorsAbout__head _col">
                            <h2 className="publicExecutorsAbout__title">Кто такие самозанятые?</h2>
                            <p className="publicExecutorsAbout__description">
                                Самозанятые — это специалисты, которые самостоятельно оказывают
                                услуги физическим и&nbsp;юридическим лицам. Такую активность легко
                                совмещать с&nbsp;основной занятостью
                            </p>
                            <a
                                rel="noreferrer"
                                className="publicExecutorsAbout__button"
                                href="https://npd.nalog.ru/app/"
                                target="_blank"
                            >
                                <Button className="_main _public">
                                    Стать самозанятым{' '}
                                    <i className="_arrowNext">
                                        <Icon name="arrow-next-2" />
                                    </i>
                                </Button>
                            </a>
                        </div>
                        <div className="publicExecutorsAbout__title">Почему это выгодно?</div>
                        {device === 'mobile' && (
                            <>
                                <div className="publicExecutorsAbout__description">
                                    Листайте вправо,
                                    <br />
                                    чтобы увидеть больше
                                </div>
                            </>
                        )}
                        {this.renderCards()}
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
    };
}

export default connect(mapStateToProps)(ExecutorsAbout);
